/* tslint:disable */
/* eslint-disable */
/**
 * Activity Feed API
 * API for managing activity feed entries including historical events, actions, and notifications.  The activity feed provides a unified timeline of events and actions for insured risks (risques assurés). It supports notifications with read/unread status tracking and badge count for UI display.  ## Entry Types - **Historique**: Historical events (e.g., mandate signed, document uploaded) - **Action**: Actionable items with due dates (e.g., pending approvals, required follow-ups)  ## Sources - **Internal**: Events generated by the platform - **External**: Events from external systems or user actions  ## Entity Links Messages can contain entity references in the format `{EntityType:Guid}` which are resolved using the `entities` array for navigation purposes. 
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ActivityMessageSegmentDto } from './ActivityMessageSegmentDto';
import {
    ActivityMessageSegmentDtoFromJSON,
    ActivityMessageSegmentDtoFromJSONTyped,
    ActivityMessageSegmentDtoToJSON,
    ActivityMessageSegmentDtoToJSONTyped,
} from './ActivityMessageSegmentDto';
import type { HistoryPriorityEnum } from './HistoryPriorityEnum';
import {
    HistoryPriorityEnumFromJSON,
    HistoryPriorityEnumFromJSONTyped,
    HistoryPriorityEnumToJSON,
    HistoryPriorityEnumToJSONTyped,
} from './HistoryPriorityEnum';
import type { ActivityFeedEntityLinkDto } from './ActivityFeedEntityLinkDto';
import {
    ActivityFeedEntityLinkDtoFromJSON,
    ActivityFeedEntityLinkDtoFromJSONTyped,
    ActivityFeedEntityLinkDtoToJSON,
    ActivityFeedEntityLinkDtoToJSONTyped,
} from './ActivityFeedEntityLinkDto';

/**
 * Represents a single history event (used for Resume and Complete granularity levels)
 * @export
 * @interface HistoryEventDto
 */
export interface HistoryEventDto {
    /**
     * Unique identifier of the event
     * @type {string}
     * @memberof HistoryEventDto
     */
    id: string;
    /**
     * Title of the event
     * @type {string}
     * @memberof HistoryEventDto
     */
    title: string;
    /**
     * Detailed message with optional entity references.
     * Entity references use the format {EntityType:Guid} (e.g., {Personne:xxx-111})
     * 
     * @type {string}
     * @memberof HistoryEventDto
     */
    message: string;
    /**
     * 
     * @type {HistoryPriorityEnum}
     * @memberof HistoryEventDto
     */
    priority: HistoryPriorityEnum;
    /**
     * Timestamp when the event was created
     * @type {Date}
     * @memberof HistoryEventDto
     */
    createdAt: Date;
    /**
     * List of entity links referenced in the message
     * @type {Array<ActivityFeedEntityLinkDto>}
     * @memberof HistoryEventDto
     */
    entities?: Array<ActivityFeedEntityLinkDto>;
    /**
     * Whether the event is new/unread
     * @type {boolean}
     * @memberof HistoryEventDto
     */
    isNew?: boolean;
    /**
     * Key of the Lucide React icon to display for this event.
     * Must match a valid Lucide icon name in PascalCase (e.g., "FileText", "User", "CheckCircle").
     * See https://lucide.dev/icons for available icons.
     * 
     * @type {string}
     * @memberof HistoryEventDto
     */
    iconKey?: string;
    /**
     * Message riche (rendre a la place de message quand present)
     * @type {Array<ActivityMessageSegmentDto>}
     * @memberof HistoryEventDto
     */
    segments?: Array<ActivityMessageSegmentDto> | null;
    /**
     * Code stable pour icone/couleur/filtre : simulation | client | risque | devis | contrat | paiement | document | note | autre
     * 
     * @type {string}
     * @memberof HistoryEventDto
     */
    category?: string | null;
    /**
     * Libelle pret a afficher (Simulation, Client, Risque...)
     * @type {string}
     * @memberof HistoryEventDto
     */
    categoryLabel?: string | null;
}



/**
 * Check if a given object implements the HistoryEventDto interface.
 */
export function instanceOfHistoryEventDto(value: object): value is HistoryEventDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function HistoryEventDtoFromJSON(json: any): HistoryEventDto {
    return HistoryEventDtoFromJSONTyped(json, false);
}

export function HistoryEventDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): HistoryEventDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'title': json['title'],
        'message': json['message'],
        'priority': HistoryPriorityEnumFromJSON(json['priority']),
        'createdAt': (new Date(json['createdAt'])),
        'entities': json['entities'] == null ? undefined : ((json['entities'] as Array<any>).map(ActivityFeedEntityLinkDtoFromJSON)),
        'isNew': json['isNew'] == null ? undefined : json['isNew'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'segments': json['segments'] == null ? undefined : ((json['segments'] as Array<any>).map(ActivityMessageSegmentDtoFromJSON)),
        'category': json['category'] == null ? undefined : json['category'],
        'categoryLabel': json['categoryLabel'] == null ? undefined : json['categoryLabel'],
    };
}

export function HistoryEventDtoToJSON(json: any): HistoryEventDto {
    return HistoryEventDtoToJSONTyped(json, false);
}

export function HistoryEventDtoToJSONTyped(value?: HistoryEventDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'title': value['title'],
        'message': value['message'],
        'priority': HistoryPriorityEnumToJSON(value['priority']),
        'createdAt': ((value['createdAt']).toISOString()),
        'entities': value['entities'] == null ? undefined : ((value['entities'] as Array<any>).map(ActivityFeedEntityLinkDtoToJSON)),
        'isNew': value['isNew'],
        'iconKey': value['iconKey'],
        'segments': value['segments'] == null ? undefined : ((value['segments'] as Array<any>).map(ActivityMessageSegmentDtoToJSON)),
        'category': value['category'],
        'categoryLabel': value['categoryLabel'],
    };
}

